import React, { useEffect, useState } from "react";
import { useNavigate,  } from "react-router-dom";

// import {
//   TABLE_DATA,
//   TABLE_HEADERS,
//   keyMapping,
 
// } from "../../../../constants/StockList";

// import ListPage from "../Shared/ListPage";
import ROUTES_NAVIGATION from "../../../../routes/routes";
import ListPage from "../../Sales/Shared/ListPage";
import axiosInstance from "../../../services/api/API";
import Loader from "../../../customComponents/CustomLoader";

const StockDetails = ({formData,setFormData=()=>{}}) => {
  const [stockData,setStockData] = useState([])
  const token = localStorage.getItem("authToken");
  const userType = localStorage.getItem("UserType");
  const bpId = localStorage.getItem("business_partner_id");
  const [totalPages, setTotalPages] = useState(0);
  const [loading, setLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(0);
  const [searchQuery,setSearchQuery] = useState("")
  const [totalRecords, setTotalRecords] = useState(0);
  const [validationErrors, setValidationErrors] = useState({});

  const [filterFormData, setFilterFormData] = useState({});
  const [filters, setFilters] = useState({});

  const [showroomOptions,setShowroomOptions] = useState([])

  const navigate = useNavigate();

  useEffect(() => {
    fetchDepartments();
  }, []);
  const apiCallFunction = () =>{
    fetchDepartments()
  }
  const handleSearchChange = (event) => {
    setSearchQuery(event.target.value);
  };

  const fetchDepartments = async (page = 0, pageSize = 10) => {

    const allfilteredData = filters;

    try {
      setLoading(true)
      const response = await axiosInstance.post(
        "/stockdetail/list",
        {
          page,
          pageSize,
          usertype: allfilteredData?.usertype ? allfilteredData?.usertype : "showroom",
          showroom_id: filterFormData?.showroomcenter ? filterFormData?.showroomcenter :null,
          searchText:searchQuery
          
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      const formattedData = response?.data?.data?.data?.map((item, index) => ({
        ...item,
        "Sr No.": index + 1,
      }));

      const totalRecordsData = response?.data?.data?.totalRecords;
      console.log("formattedData", formattedData);
      setTotalRecords(totalRecordsData);

      setStockData(formattedData);
      console.log("response", response);
      setTotalPages(Math.ceil(response?.data?.data?.totalRecords / pageSize));
    } catch (error) {
      console.error("Error fetching department list:", error);
    }
    finally{
      setLoading(false)
    }
  };

  useEffect(() => {
    ShowroomList()
  },[])
// useEffect(()=>{
//   if(filterFormData.userType==='showroom'){}
// },[])
  const ShowroomList = async () => {
    console.log("called");
    
    try{
      const response = await axiosInstance.post("/showroom/ddlshowroom",{
        business_partner_id: bpId==0?null:bpId,
      }, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      })

      const data = response?.data?.data?.data
      const vendorNameOptions = data.map(user => ({
        value: user.ID,
        label:user.NAME,
      }))
      setShowroomOptions(vendorNameOptions)
    }catch(error) {
      console.log(error)
    }
  }

  const filtersInputs = [
    ...(userType === "superadmin"|| userType ==="businesspartner"
      ? [
        {
          name: "usertype",
          label: "User Type",
          placeholder: "Select Usertype",
          type: "dropdown",
          options: [
            {
              label: "Showroom",
              value: "showroom",
            },
            {
              label: "Oem",
              value: "oem",
            },
          ],
          required: true,
          gridClass: "col-lg-3",
        }
        ]
      : []),
      
      ...( userType === 'dealeruser' || filterFormData.usertype=== 'showroom'
        ? [
          {
            name: "showroomcenter",
            label: "Showroom Center",
            type: "dropdown",
            options: showroomOptions,
            required: true,
            gridClass: "col-lg-4",
          }
          ]
        : []),
      
   
  ];

  useEffect(() => {
    fetchDepartments();
  }, [filters]);

  const clearFilter = () => {
    setFilterFormData({});
    setFilters({});
    fetchDepartments();
  };

  const handleSearch = () => {
    // Update the filters state with the current form data
    setFilters({
      usertype: filterFormData.usertype || null,
    });
  };

  const TABLE_HEADERS = [
    // "Sr. No.",
    "Showroom Center Name",
    "Item Name",
    "Item Type",
    "Purchase Price",
    "Selling Price",
    "Goods Balance",
    "Defective balance",
    "Missing Balance",
    "Order Quantity",
    "Pending Quantity"
   
  ];

  const keyMapping = {
    "Showroom Center Name":"showroom_name",
    "Item Name":"itemname",
    "Item Type":"itemtypename",
    "Purchase Price":"purchase_price",
    "Selling Price":"selling_price",
    "Goods Balance":"good_qty",
    "Defective balance":"defective_qty",
    "Order Quantity":"accepted_qty",
    "Missing Balance":"missing_qty",
    "Pending Quantity":"pending_qty"
  };
  const handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      apiCallFunction(0, 10,searchQuery); 
    }
  } 
  return (
    <div>
    {loading ? ( 
      <Loader />
    ) : (
      <div>
    <ListPage
      isButtonRequired={false}
      headerTopText="Sales / Stock Lists"
      headerTitle="Stock Lists"
      listTitle="All Stocks"
    totalRecords={totalRecords}
    currentPage={currentPage}
totalPages={totalPages}
      tableData={stockData}
      tableHeaders={TABLE_HEADERS}
      keyMapping={keyMapping}
      filterInputs={filtersInputs}
      validationErrors={validationErrors}
      setValidationErrors={setValidationErrors}
      filterFormData={filterFormData}
      setFilterFormData={setFilterFormData}
      handleFormSubmit={handleSearch}
      handleClear={clearFilter}
      formData={formData}
      setFormData={setFormData}
      isFilterRequired= {userType==='showroomuser'?false:true}
      searchplaceholder="Search by Item Type"
      searchQuery={searchQuery}
      setSearchQuery={setSearchQuery}
      fetchDepartments={fetchDepartments}
      handleSearchChange={handleSearchChange}
      handleKeyPress={handleKeyPress} 
      apiCallFunction={apiCallFunction}
    />
        </div>
    )}
    </div>
  );
};

export default StockDetails;
